module.exports = __webpack_public_path__ + "img/fan_gray.48964b99.png";